// extracted by mini-css-extract-plugin
module.exports = {"root":"Status_root__36bQ9","approved":"Status_approved__eFqB3","rejected":"Status_rejected__2IvQq","expired":"Status_expired__3zSHV","label":"Status_label__2Oc3m"};